module.exports = __webpack_public_path__ + "img/61.488b60e6.svg";